import React from 'react';
import { motion } from 'framer-motion';

export default function Section({ section, id, reverse = false, dark = false }) {
  if (!section) return null;

  return (
    <section 
      id={id} 
      className={`${id === 'contribution' ? 'py-12 sm:py-16' : 'py-24 sm:py-32'} overflow-hidden ${id === 'contribution' ? 'bg-gray-100 text-gray-900 border-t-4 border-red-600' : (dark ? 'bg-black text-white' : 'bg-white text-black')}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid lg:grid-cols-2 gap-16 items-center ${reverse ? 'lg:flex-row-reverse' : ''}`}>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className={reverse ? 'lg:order-2' : ''}
          >
            <h2 className={`text-3xl sm:text-4xl font-black mb-8 tracking-tight uppercase ${id === 'contribution' ? 'text-red-600' : (dark ? 'text-white' : 'text-black')}`}>
              {section.title}
            </h2>
            <div 
              className={`prose prose-lg max-w-none ${id === 'contribution' ? 'text-gray-600' : (dark ? 'text-white prose-invert' : 'text-gray-600')} prose-headings:text-inherit prose-strong:text-inherit`}
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            className={`relative ${reverse ? 'lg:order-1' : ''}`}
          >
            {id === 'contribution' && (
              <div className="absolute -inset-4 bg-red-600/20 blur-3xl rounded-full -z-10 animate-pulse" />
            )}
            <div className={`relative aspect-[16/10] overflow-hidden rounded-3xl shadow-2xl ${id === 'contribution' ? 'ring-1 ring-black/5' : (dark ? 'ring-1 ring-white/10' : 'ring-1 ring-black/5')}`}>
              {section.image?.[0] ? (
                <img
                  src={section.image[0]}
                  alt={
                    id === 'membership'
                      ? 'DAPAO community members gathered around tables'
                      : id === 'contribution'
                      ? 'Young people gathered at a DAPAO activity'
                      : section.title
                  }
                  className="w-full h-full object-cover"
                />
              ) : (
                <img
                  src="https://assets.auxodev.dk/assets/c15c4fdc-8908-4ddc-a4c7-4bd7c9025029/9f8ace64-5dd4-4016-880b-a74ab2139df2.jpg"
                  alt={section.title}
                  className="w-full h-full object-cover"
                />
              )}

              {/* Floating Peace Dove Card on top of the image */}
              {id === 'membership' && (
                <motion.div
                  initial={{ opacity: 0, scale: 0.9, y: 10 }}
                  whileInView={{ opacity: 1, scale: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  className="absolute bottom-4 left-4 right-4 sm:right-auto sm:left-6 sm:bottom-6 bg-white/95 p-4 rounded-2xl shadow-xl max-w-[280px] z-20 border border-gray-100 flex items-center gap-4 hover:shadow-2xl transition-shadow duration-300"
                >
                  <img 
                    src="https://assets.auxodev.dk/assets/c15c4fdc-8908-4ddc-a4c7-4bd7c9025029/dapao-dove-palestine-colors.webp" 
                    alt="Flying dove in Palestinian colours holding an olive branch" 
                    className="w-14 h-14 object-contain rounded-xl bg-red-50/50 p-1 shrink-0"
                  />
                  <div>
                    <h4 className="text-gray-900 font-bold text-sm">Fred & Solidaritet</h4>
                    <p className="text-gray-500 text-xs mt-1">DAPAO arbejder for fredelig sameksistens og ligestilling.</p>
                  </div>
                </motion.div>
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
